import { Component, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { toObservable } from '@angular/core/rxjs-interop';
import { TranslocoModule } from '@ngneat/transloco';
import { combineLatest, filter } from 'rxjs';
import { SvcActionPlanHistoryService } from '../../services/svc-action-plan-history.service';
import { LibSharedCommonModule } from 'projects/lib-shared-common/src/public-api';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

type HistoryIconType = 'escalated' | 'rescheduled' | 'included';

@Component({
    selector: 'svc-action-plan-history-tab',
    standalone: true,
    imports: [CommonModule, LibSharedCommonModule, MatProgressSpinnerModule, TranslocoModule],
    templateUrl: './svc-action-plan-history-tab.component.html',
    styleUrls: ['./svc-action-plan-history-tab.component.scss'],
})
export class SvcActionPlanHistoryTabComponent {
    public readonly actionPlanId = input<number | null>(null);
    public readonly refreshTrigger = input<number>(0);

    public readonly historyService = inject(SvcActionPlanHistoryService);

    constructor() {
        combineLatest([
            toObservable(this.actionPlanId),
            toObservable(this.refreshTrigger),
        ]).pipe(
            filter(([actionPlanId, refreshTick]) => refreshTick > 0 && !!actionPlanId),
            takeUntilDestroyed(),
        ).subscribe(([actionPlanId]) => {
            this.historyService.getHistoryLogs(actionPlanId!);
        });
    }

    public getIconType(actionType?: string): HistoryIconType {
        switch ((actionType ?? '').trim().toUpperCase()) {
            case 'ESCALATED':
            case 'ESCALATION':
            case 'ESCALATE':
                return 'escalated';
            case 'RESCHEDULED':
            case 'RESCHEDULE':
            case 'REPROGRAMMED':
            case 'REPROGRAM':
                return 'rescheduled';
            default:
                return 'included';
        }
    }
}
